import emailjs from "emailjs-com";
import config from "../config";
const SERVICE_ID = 'service_mu44gro';
const USER_ID = 'user_twJMhT1XLr7XXXXXXXXXX';
const TEMPLATE_ID = 'template_Cujx6f2Q';
const TEMPLATE2_ID = 'template_ohklxll';
const PUBLIC_KEY = 'user_E106qMc87ZzZOXaixPOMl';

const full_url = config.nav.full_url;
const reply_to = config.nav.email;
const sendEmailToCandidate = async(currentUser) => {
    let message = "Votre candidature APAFReP a bien été enregistrée avec succès !";
    let email = currentUser.email;
    let name = currentUser.name;
    let subject = "APAFReP - Votre candidature";
    let ans;
    
    const data = {
        subject,
        name,
        email,
        message,
        reply_to
    }

    await emailjs.send(SERVICE_ID, TEMPLATE2_ID, data, PUBLIC_KEY)
      .then((result) => {
          console.log(result.text);
          ans = true;
      }, (error) => {
          console.log(error.text);
          ans = false;
      });
    return ans;
};

const sendEmailToExam = async(currentUser) => {
    let message = "Votre rapport d'activité a bien été enregistrée avec succès !";
    let email = currentUser.email;
    let name = currentUser.name;
    let subject = "APAFReP - Votre candidature";
    let ans;
    
    const data = {
        subject,
        name,
        email,
        message,
        reply_to
    }

    await emailjs.send(SERVICE_ID, TEMPLATE2_ID, data, PUBLIC_KEY)
      .then((result) => {
          console.log(result.text);
          ans = true;
      }, (error) => {
          console.log(error.text);
          ans = false;
      });
    return ans;
};

const sendEmailToAdmin = async(account) => {
    let email = account.email;
    let name = account.displayName;
    let password = account.password;
    let type;
    let ans;
    if(account.type === 'admin'){
        type = 'Administrateur';
    }
    else{
        type = 'Examinateur';
    }
    const data = {
        name,
        email,
        password,
        type,
        full_url,
        reply_to
    }
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, data, PUBLIC_KEY)
      .then((result) => {
          console.log(result.text);
          ans = true;
        }, (error) => {
            console.log(error.text);
            ans = false;
      });
    return ans;
}

const emailController = {
    sendEmailToExam,
    sendEmailToCandidate,
    sendEmailToAdmin
}
  
export default emailController